import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import Rating from '@mui/material/Rating';


export default function CoachTopServices({ services }) {
  return (
    <>
      <Box my={8} >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5 }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize:{md: "26px", xs: "16px"},
              lineHeight: {md: "32px", xs: "25px"},
            }}
          >
            Top Services on PPLACD
          </Typography>
          <Link style={{ textDecoration: 'none', color: '#2544EE' }}>
            <Typography >View More </Typography>
          </Link>
        </Box>
        <Box>
          <Grid container spacing={2} mb={10}>
            {
              services && services.length > 0
                ?
                services.splice(0,3).map((item, index) => (
                  <Grid item md={4} key={index}>
                    <Box sx={{ width: '100%', bgcolor: '#F8FAFF', border: '1px solid #D2D2D2', borderRadius: '8px', boxShadow: '0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014' }}>
                      <Box p={3}>
                        <Typography sx={{ fontFamily: 'Inter', fontWeight: 600, fontSize: '18px', lineHeight: '30px' }}>{item.serviceName}</Typography>
                        <Rating name="half-rating-read" defaultValue={4} precision={0.5} readOnly />
                        <Typography sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '24px' }}>More than 20K+ Join</Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))
                :
                ""
            }

          </Grid>
        </Box>
      </Box>
    </>
  );
}
